import { BadgeCheck } from "lucide-react";

const places = [
  "México",
  "Guatemala",
  "El Salvador",
  "Honduras",
  "Nicaragua",
  "Costa Rica",
  "Panamá",
  "Belice",
  "Sudamérica",
  "Estados Unidos (Phoenix, AZ)",
];

const CoverageBanner = () => (
  <section
    aria-label="Cobertura autorizada"
    className="bg-primary text-primary-foreground py-4"
  >
    <div className="container flex flex-col md:flex-row md:items-center gap-3 md:gap-6">
      <p className="flex items-center gap-2 text-sm font-semibold shrink-0">
        <BadgeCheck size={18} aria-hidden="true" />
        Distribuidor autorizado de DocuWare en Latinoamérica y Estados Unidos:
      </p>
      <ul className="flex flex-wrap gap-2">
        {places.map((place) => (
          <li
            key={place}
            className="rounded-full border border-primary-foreground/25 bg-primary-foreground/10 px-3 py-1 text-xs font-medium"
          >
            {place}
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default CoverageBanner;
